import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import {
  AppBar, Toolbar, Typography, Button, Box, IconButton, Drawer, List, ListItem, ListItemIcon, ListItemText,
  useMediaQuery, useTheme,
} from '@mui/material'
import { Menu as MenuIcon, Movie, Home, History, Login, Logout, Person } from '@mui/icons-material'

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, signOut } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [drawerOpen, setDrawerOpen] = React.useState(false)

  const navItems = [
    { label: '首页', icon: <Home />, path: '/' },
    ...(user ? [{ label: '观看记录', icon: <History />, path: '/history' }] : []),
  ]

  const handleSignOut = async () => {
    await signOut()
    navigate('/login')
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0a0a0a' }}>
      <AppBar position="sticky" sx={{ bgcolor: '#1a1a2e' }}>
        <Toolbar>
          {isMobile && (
            <IconButton edge="start" onClick={() => setDrawerOpen(true)} sx={{ mr: 1, color: '#fff' }}>
              <MenuIcon />
            </IconButton>
          )}
          <Movie sx={{ mr: 1, color: '#e50914' }} />
          <Typography
            variant="h6" onClick={() => navigate('/')}
            sx={{ flexGrow: 1, cursor: 'pointer', fontWeight: 'bold', color: '#fff' }}
          >
            Mini Movie
          </Typography>
          {!isMobile && navItems.map(item => (
            <Button
              key={item.path} startIcon={item.icon}
              onClick={() => navigate(item.path)}
              sx={{ color: location.pathname === item.path ? '#e50914' : '#aaa', mx: 0.5 }}
            >
              {item.label}
            </Button>
          ))}
          {user ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {!isMobile && (
                <Typography variant="body2" sx={{ color: '#aaa', maxWidth: 120 }} noWrap>
                  <Person fontSize="small" sx={{ mr: 0.5, verticalAlign: 'middle' }} />
                  {user.email}
                </Typography>
              )}
              <Button onClick={handleSignOut} startIcon={<Logout />} sx={{ color: '#aaa' }}>
                退出
              </Button>
            </Box>
          ) : (
            <Button onClick={() => navigate('/login')} startIcon={<Login />} sx={{ color: '#e50914' }}>
              登录
            </Button>
          )}
        </Toolbar>
      </AppBar>

      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)} sx={{ '& .MuiDrawer-paper': { bgcolor: '#1a1a2e', color: '#fff' } }}>
        <Box sx={{ width: 250, pt: 2 }}>
          <Typography variant="h6" sx={{ px: 2, mb: 2, color: '#e50914' }}>Mini Movie</Typography>
          <List>
            {navItems.map(item => (
              <ListItem key={item.path} onClick={() => { navigate(item.path); setDrawerOpen(false) }} sx={{ cursor: 'pointer' }}>
                <ListItemIcon sx={{ color: location.pathname === item.path ? '#e50914' : '#aaa' }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} sx={{ color: location.pathname === item.path ? '#e50914' : '#aaa' }} />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      <Box component="main">{children}</Box>
    </Box>
  )
}

export default Layout
